import React from 'react';
import "../../../App.css";

const AlertMessage = (props) => {

  let errorMessage = "";

  if (props.alertMessage.hasOwnProperty("message") &&
    props.alertMessage.message?.length > 0) {
    errorMessage = props.alertMessage.message;
  } else {
    errorMessage = "We encountered an unexpected issue. Please contact support."
  }

  return (
    <>
      {errorMessage && (
        <div className="processing-container error-container">
          <div className="error-icon">⚠️</div>
          <h1 className="congratulations-title error-title">Ooops!</h1>
          <h2 className="congratulations-subtitle">Something went wrong</h2>
          <p className="congratulations-message">
            {errorMessage}
          </p>
        </div>
      )}
    </>
  )
}

export default AlertMessage;